/**
 * Helpers for the shared (non-impersonation) Supabase session in localStorage.
 * Impersonation tabs persist their session in sessionStorage under a different
 * key; these helpers read/write the staff product session without touching it.
 */

export function getDefaultAuthStorageKey(): string {
    const supabaseUrl = import.meta.env.VITE_APP_SUPABASE_URL as string
    const hostname = new URL(supabaseUrl).hostname
    return `sb-${hostname.split('.')[0]}-auth-token`
}

/** Raw JSON of the persisted staff/product session, if any. */
export function readPersistedLocalSessionRaw(): string | null {
    try {
        return localStorage.getItem(getDefaultAuthStorageKey())
    } catch {
        return null
    }
}

/**
 * Write a previously stashed staff session back to localStorage only when the
 * shared slot is empty (another tab may have refreshed it while we impersonated).
 */
export function restorePersistedLocalSession(stashRaw: string): void {
    const key = getDefaultAuthStorageKey()
    try {
        if (localStorage.getItem(key)) return
        const parsed = JSON.parse(stashRaw) as { access_token?: string; refresh_token?: string }
        if (!parsed?.access_token || !parsed?.refresh_token) return
        localStorage.setItem(key, stashRaw)
    } catch {
        // Ignore malformed stash; the next page load will send the user to login.
    }
}
